<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Tracker</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item-divider color="tertiary">
            Tracker Options
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="trackerLive" href="javascript:;"
                (click)="onTrackerLiveClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Live Tracker</span><br />
                <span class="line2">Watch your shuttles in real-time navigate around town.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="trackerHistorical" href="javascript:;"
                (click)="onTrackerHistoricalClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Historical Tracker</span><br />
                <span class="line2">View your shuttles previous routes.</span>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>